<template>
  <section class="flex flex-wrap">
    <template v-if="emp">
      <div class="w-2/3 pl-4">
        <img class="w-80 mb-4" src="@/assets/images/bg/hpbd-text.svg">
        <h3 class="text-3xl text-blue-800 font-black">
          {{emp.honorific}}. {{emp.aka_name}}
        </h3>
        <p v-if="emp.job_title" class="text-2xl text-blue-500" style="height: 2.5em">
          {{emp.job_title.name}}
        </p>
        <p class="text-4xl mt-2 font-black text-yellow-500">{{$zodiac.formatDateWithoutYearLocaleVN(emp.dob)}}</p>
      </div>
    </template>
    <h3 v-else class="w-2/3 pl-4 flex items-center text-3xl text-blue-800 font-black">
      <p v-html="noDataMessage"></p>
    </h3>
    <div class="w-1/3 flex items-end p-2">
      <div class="emp-avatar w-full rounded-full bg-cover relative"
        :style="{
          backgroundImage: `url(
            ${emp ? $zodiac.makeImage(emp.avatar && emp.avatar.url) : $zodiac.getImagePlaceholder()}
          )`,
          paddingBottom: '100%'
        }">
        <img src="@/assets/images/bg/hpbd-ribbon.svg" class="absolute bottom-0 left-0 right-0">
      </div>
    </div>
  </section>
</template>

<script>

export default {
  props: ['emp', 'noDataMessage'],
}
</script>

<style>

</style>